// src/components/common/StyledTab.js
import React from 'react';
import { Tab } from '@mui/material';

const StyledTab = ({ label, active, ...props }) => {
  return (
    <Tab
      label={label}
      disableRipple
      sx={{
        textTransform: 'none',
        fontWeight: active ? 'bold' : 'normal',
        color: active ? '#fff' : 'inherit',
        // backgroundColor: active ? 'rgb(12, 26, 50)' : 'transparent',
        '&:hover': {
          backgroundColor: 'rgb(12, 26, 50)',
          color: '#fff',
        },
      }}
      {...props}
    />
  );
};

export default StyledTab;
